import { render, staticRenderFns } from "./OP_BasicSummaryPrintable.vue?vue&type=template&id=85d02bf8&scoped=true&"
import script from "./OP_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./OP_BasicSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./OP_BasicSummaryPrintable.vue?vue&type=style&index=0&id=85d02bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d02bf8",
  null
  
)

export default component.exports